import {
  PlatformRBACDefaultRole,
  PlatformLocalUserWithTeams,
  PlatformTeam,
} from '@cloudquery/api-platform';

import {
  DEPENDANT_PERMISSIONS,
  ROLE_TO_PERMISSIONS,
  PlatformPermissions,
} from '@/constants/platformPermissions';

const mapRolesToPermissions = (roles: string[]) => {
  const permissionsQueue = roles.flatMap(
    (role) => ROLE_TO_PERMISSIONS[role as PlatformRBACDefaultRole],
  );

  const permissionsSet = new Set<PlatformPermissions>();

  while (permissionsQueue.length > 0) {
    const currentPermission = permissionsQueue.shift();

    if (!currentPermission || permissionsSet.has(currentPermission)) {
      continue;
    }

    permissionsSet.add(currentPermission);
    permissionsQueue.push(...DEPENDANT_PERMISSIONS[currentPermission]);
  }

  return [...permissionsSet];
};

export const getUserTeamsPermissions = (
  user: PlatformLocalUserWithTeams,
  currentTeam: PlatformTeam,
): PlatformPermissions[] => {
  const userTeam = user.teams.find((team) => team.team_name === currentTeam.name);

  if (!userTeam) {
    return [PlatformPermissions.GENERAL_READ];
  }

  return mapRolesToPermissions(userTeam.roles);
};

export const getUserPlatformPermissions = (user: PlatformLocalUserWithTeams) =>
  mapRolesToPermissions(user.roles || []);
